import React, { useEffect, useRef, useState } from "react";
import {
  _LOGO,
  ANAMBRA_LOGO,
  LOGO_BLACK,
} from "../../../utils-func/image_exports";
import ButtonV2 from "../buttonV2";
import { useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { Fade } from "react-awesome-reveal";
import { Store } from "../../../states/store";
import { useAppSelector } from "../../../hooks";
import { selectToken } from "../../../states/slices/authReducer";

function Header() {
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement>(null);
  const [showMenu, setShowMenu] = useState(false);
  const token = useAppSelector(selectToken);
  const handleScroll = (elem: string) => {
    const element = document.getElementById(elem);
    if (elem) {
      element?.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowMenu(false);
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* <div className="fixed z-50 top-52 w-full bg-[#FFFFFF66] backdrop-blur-[100px]">
        <img
          src={ANAMBRA_LOGO}
          className="w-[190px] h-[160px] object-contain"
          alt=""
        />
      </div> */}

      <div
        id="header"
        className="w-full  bg-[#FFCC29] h-full lg:py-10 py-5 lg:px-28 px-5 flex items-center justify-between"
      >
        <div
          className="flex items-center gap-x-2 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img
            src={LOGO_BLACK}
            className="w-[40.8px] h-[40.8px] object-contain"
            alt=""
          />
          <span className="text-[23px] lg:block hidden font-bold text-black">
            JudexAI (Judge)
          </span>
        </div>

        {showMenu && (
          <div
            ref={menuRef}
            className="w-fit p-5 rounded-xl lg:hidden shadow-lg bg-[#FFCC29] top-10 mt-7 flex flex-col fixed z-50 right-3"
          >
            <span
              className="text-lg font-semibold text-black cursor-pointer"
              onClick={() => {
                handleScroll("features");
                setShowMenu(false);
              }}
            >
              Features
            </span>
            <span
              className="text-lg font-semibold text-black cursor-pointer"
              onClick={() => {
                handleScroll("how-it-works");
                setShowMenu(false);
              }}
            >
              How it works
            </span>
          </div>
        )}

        <div className="relative">
          <span
            className="cursor-pointer lg:hidden flex"
            onClick={() => setShowMenu((prev) => !prev)}
          >
            <FaBars color="white" />
          </span>
        </div>
        <div className="lg:flex hidden items-center gap-x-10 w-fit">
          <span
            className="text-lg font-semibold text-black cursor-pointer"
            onClick={() => handleScroll("features")}
          >
            Features
          </span>
          <svg
            width="2"
            height="17"
            viewBox="0 0 2 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path opacity="0.5" d="M1 0.5V16.5" stroke="white" />
          </svg>
          <span
            className="text-lg font-semibold text-black cursor-pointer"
            onClick={() => handleScroll("how-it-works")}
          >
            How it works
          </span>
          <svg
            width="2"
            height="17"
            viewBox="0 0 2 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path opacity="0.5" d="M1 0.5V16.5" stroke="white" />
          </svg>
          {token ? (
            <ButtonV2
              title={"Chat with JudexAI"}
              btnStyle={"bg-black w-fit px-5 h-full rounded-xl py-4"}
              textStyle={"text-white font-semibold"}
              handleClick={() => navigate("/home", { replace: true })}
            />
          ) : (
            <ButtonV2
              title={"Get started"}
              btnStyle={"bg-black w-[134px] h-full rounded-xl py-4"}
              textStyle={"text-white font-semibold"}
              handleClick={() => navigate("/sign-up", { replace: true })}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
